import { IanaTimeZone, TimeZone } from '../../types'

const createTimeZonesFromGroups = (timezones: Record<IanaTimeZone, TimeZone>): Record<IanaTimeZone, TimeZone> => {
  const result = Object.keys(timezones).reduce((acc: Record<string, TimeZone>, key: string) => {
    const timezone = timezones[key]
    acc[key] = { ...timezone, name: key }

    if (timezone.group) {
      timezone.group.forEach((groupName: string) => {
        acc[groupName] = { ...timezone, name: groupName }
      })
    }
    return acc
  }, {})
  return Object.fromEntries(Object.entries(result).sort(([keyA], [keyB]) => keyA.localeCompare(keyB)))
}

export { createTimeZonesFromGroups }
